import { Data2 } from "../../../../../features/data-types"
import { Emitter, Event } from "../../../../../features/event-emitter"
import { TableName } from "../../../../../tables"
import { useAdministrationState } from "../../../../administration"
import { DeliveryData, DeliveryMethod, useDeliveryOrderService } from "../../../../deliveries"
import { usePurchaseService } from "../../../services/purchaseService"

export const useActions = () => {
    const { currentEmployee } = useAdministrationState()

    const { createPurchase, updatePurchase } = usePurchaseService()
    const { createDeliveryOrder } = useDeliveryOrderService()
    
    const submitPurchase = async (
        data: Data2,
        branchId: string,
        itemsData: Data2[],
        partialDeliveryData?: Partial<DeliveryData>,
        createMode?: boolean
    ) => {
        const { id, supplierId } = data
        
        const deliveryData = {
            ...partialDeliveryData,
            method: DeliveryMethod.RECEPTION
        }
        const purchaseData = {
            id,
            deliveryData,
            deliveryBranchId: branchId,
            supplierId,
            employeeId: currentEmployee!.id,
        }

        if (createMode) {
            const savedPurchase = await createPurchase(purchaseData, itemsData)
            
            const deliveryOrderData: Data2 = {
                table: TableName.PURCHASE_ORDERS,
                operationId: savedPurchase.id,
                method: DeliveryMethod.RECEPTION,
                deliveryDate: deliveryData.deliveryDate,
                addressId: deliveryData.addressId
            }
            const deliveryOrderItemsData = savedPurchase.items.map(item => ({
                itemId: item.id,
                quantity: item.quantity
            }))
            await createDeliveryOrder(savedPurchase, deliveryOrderData, deliveryOrderItemsData)
        } else {
            await updatePurchase(purchaseData, itemsData)
        }
        
        Emitter.emit(Event.DB_SUBMIT_DONE, createMode)
    }

    return {
        submitPurchase
    }
}
